var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { getValidationError } from "core/Form/helpers";
// new component - replaces legacy component from core/Form
import FormElementContainer from "core/FormElementContainer";
import { IconContainer, Input, SuccessIcon } from "./styles";
var FormInput = function (_a) {
    var className = _a.className, inputRef = _a.inputRef, placeholderText = _a.placeholderText, labelText = _a.labelText, hideLabel = _a.hideLabel, onChange = _a.onChange, onKeyPress = _a.onKeyPress, onBlur = _a.onBlur, errorMessageOverride = _a.errorMessageOverride, validation = _a.validation, _b = _a.darkMode, darkMode = _b === void 0 ? false : _b, _c = _a.size, size = _c === void 0 ? "lg" : _c, _d = _a.width, width = _d === void 0 ? "100%" : _d, _e = _a.bottomSpacing, bottomSpacing = _e === void 0 ? "none" : _e, _f = _a.isDisabled, isDisabled = _f === void 0 ? false : _f, _g = _a.type, type = _g === void 0 ? "text" : _g, _h = _a.value, value = _h === void 0 ? "" : _h, iconLeft = _a.iconLeft, iconRight = _a.iconRight, _j = _a.hideErrorOnFocus, hideErrorOnFocus = _j === void 0 ? true : _j, inputAttributes = __rest(_a, ["className", "inputRef", "placeholderText", "labelText", "hideLabel", "onChange", "onKeyPress", "onBlur", "errorMessageOverride", "validation", "darkMode", "size", "width", "bottomSpacing", "isDisabled", "type", "value", "iconLeft", "iconRight", "hideErrorOnFocus"]);
    var _k = useState(errorMessageOverride), errorMessage = _k[0], setErrorMessage = _k[1];
    var _l = useState(false), success = _l[0], setSuccess = _l[1];
    var _m = useState(false), focused = _m[0], setFocused = _m[1];
    var validateInput = function (input) {
        var validationError = getValidationError({ input: input, validation: validation });
        setErrorMessage(validationError);
        setSuccess(validationError ? false : true);
    };
    useEffect(function () {
        if (errorMessageOverride === undefined)
            return;
        setErrorMessage(errorMessageOverride);
        if (errorMessageOverride) {
            setSuccess(false);
        }
        else {
            setSuccess(true);
        }
    }, [errorMessageOverride, setSuccess]);
    var handleFocus = function () {
        setFocused(true);
    };
    var handleBlur = function (e) {
        setFocused(false);
        if (validation)
            validateInput(e.target.value);
        if (typeof onBlur === "function")
            onBlur();
    };
    return (_jsxs(FormElementContainer, { className: className, isFocused: hideErrorOnFocus && focused, labelText: labelText, errorMessage: errorMessage, width: width, bottomSpacing: bottomSpacing, darkMode: darkMode, hideLabel: hideLabel, children: [!!iconLeft && !iconRight && (_jsx(IconContainer, { size: size, iconLeft: iconLeft, children: iconLeft })), _jsx(Input, __assign({}, inputAttributes, { ref: inputRef, type: type, width: width, placeholder: placeholderText, onChange: function (e) {
                    return e.target && onChange && onChange(e.target.value);
                }, onBlur: handleBlur, onFocus: handleFocus, value: value, darkMode: darkMode, size: size, success: success, iconLeft: iconLeft, iconRight: iconRight, disabled: isDisabled, onKeyPress: onKeyPress })), success && _jsx(SuccessIcon, { darkMode: darkMode, size: size, success: success }), !iconLeft && !!iconRight && !success && (_jsx(IconContainer, { size: size, iconLeft: iconLeft, children: iconRight }))] }));
};
FormInput = styled(FormInput)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
export default FormInput;
var templateObject_1;
